import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useNavigate, useLocation } from 'react-router-dom';
import { IconButton, Tooltip, Stack, Icon, Typography } from 'investira.react.components';
import { formats, dates, validators } from 'investira.sdk';
import Impacto from '../../_components/Impacto';
import { BulkContextActions, DataTable } from '../../../../components/organisms';
import withAvaliacoesQuestoes from '../../../../hoc/withAvaliacoesQuestoes';

const QuestoesSettings = memo(props => {
  const { enquadramentos, state, columns, renderDetailPanel, onBulkDeleteClick, ...restProps } =
    props;

  const navigate = useNavigate();
  const location = useLocation();

  const xColumns = useMemo(() => {
    return [
      {
        id: 'id',
        accessorKey: 'id',
        header: 'ID',
        enableColumnActions: false,
        enableSorting: false,
        size: 40,
        muiTableHeadCellProps: {
          sx: {
            textAlign: 'right'
          }
        },
        Cell: ({ cell }) => {
          if (validators.isNull(cell.getValue())) {
            return null;
          }
          return cell.getValue();
        }
      },
      {
        id: 'questao',
        accessorKey: 'questao',
        header: 'Questão',
        enableColumnActions: false,
        enableSorting: false,
        //size: 200,
        muiTableHeadCellProps: {
          sx: {
            minWidth: '300px !important'
          }
        },
        Cell: ({ cell }) => {
          if (validators.isNull(cell.getValue())) {
            return null;
          }
          return cell.getValue();
        }
      },
      // {
      //   id: 'peso',
      //   accessorKey: 'peso',
      //   header: 'Peso',
      //   enableColumnActions: false,
      //   enableSorting: false,
      //   muiTableHeadCellProps: {
      //     sx: {
      //       width: '100% !important'
      //     }
      //   },
      //   Cell: ({ cell }) => {
      //     if (validators.isNull(cell.getValue())) {
      //       return null;
      //     }
      //     // return cell.getValue();
      //     return <Impacto label="" defaultValue={cell.getValue()} variant="readValue" />;
      //   }
      // },
      {
        id: 'modelos',
        accessorKey: 'modelos',
        header: 'Modelos',
        enableColumnActions: false,
        enableSorting: false,
        muiTableHeadCellProps: {
          sx: {
            width: '100% !important'
          }
        },
        Cell: ({ cell }) => {
          if (validators.isNull(cell.getValue())) {
            return null;
          }
          const xModelos = cell.getValue();
          if (Array.isArray(xModelos)) {
            return <Typography variant="caption">{xModelos.join(', ')}</Typography>;
          }
          return <Typography variant="caption">{xModelos}</Typography>;
        }
      },
      {
        id: 'sessao_label',
        accessorKey: 'sessao_label',
        header: 'Sessão',
        enableColumnActions: false,
        enableSorting: false,
        muiTableHeadCellProps: {
          sx: {
            width: '100% !important'
          }
        },
        Cell: ({ cell }) => {
          if (validators.isNull(cell.getValue())) {
            return null;
          }
          return <Typography variant="caption">{cell.getValue()}</Typography>;
        }
      }
    ];
  }, []);

  const xProps = {
    columns: xColumns,
    data: props.avaliacoes,
    readData: props.readAvaliacoes,
    isLoading: props.isLoading,
    initialState: {
      pagination: props.pagination,
      columnVisibility: { carteira: false },
      columnSizing: {
        // Define larguras fixas para as colunas de seleção e ações
        'mrt-row-select': 50, // Largura fixa para a coluna de seleção
        'mrt-row-actions': 80 // Largura fixa para a coluna de ações
      },
      density: 'comfortable'
    },
    manualFiltering: true,
    manualSorting: true,
    manualPagination: true,
    getRowId: row => row.log_id,
    state: {
      isLoading: props.isLoading,
      pagination: props.pagination,
      showProgressBars: props.isRefetching,
      columnFilters: props.columnFilters,
      sorting: props.sorting,
      rowSelection: props.rowSelection
    },
    rowCount: props.rowCount,
    onColumnFiltersChange: props.setColumnFilters,
    onSortingChange: props.setSorting,
    onPaginationChange: props.setPagination,
    onRowSelectionChange: props.setRowSelection,
    onGlobalFilterChange: props.setGlobalFilter,
    //onBulkDeleteClick: props.bulkDeleteLogs,
    enableRowSelection: true,
    renderTopToolbarCustomActions: ({ table }) => {
      const selectedRows = table.getSelectedRowModel().rows;
      const isSomeRowSelected = selectedRows.length > 0;

      return (
        <BulkContextActions
          onDeleteClick={() => {
            props.bulkDeleteEnquadramentos(selectedRows);
          }}
          disabled={props.isLoading || props.isRefetching || !isSomeRowSelected}
        />
      );
    },
    muiTableContainerProps: {
      sx: {
        maxWidth: '100%' // Garante que a tabela ocupe 100% do espaço disponível
      }
    },
    displayColumnDefOptions: {
      'mrt-row-actions': {
        size: 80 // largura em pixels para a coluna de ações
      },
      'mrt-row-select': {
        size: 50 // largura em pixels para a coluna de seleção
      }
    },
    renderRowActions: ({ row }) => {
      return (
        <Stack direction="row" spacing={1}>
          <Tooltip title="Editar">
            <span>
              <IconButton
                color="primary"
                onClick={() =>
                  navigate(`${location.pathname}/edit/${row.original.id}`, { state: row.original })
                }>
                <Icon iconName="edit" size={18} />
              </IconButton>
            </span>
          </Tooltip>
        </Stack>
      );
    },
    ...restProps
  };

  return <DataTable {...xProps} />;
});

QuestoesSettings.displayName = 'QuestoesSettings';

export default withAvaliacoesQuestoes(QuestoesSettings);
